import { SettingsServiceTypes as Types } from 'common/settingsService/types';

export class SettingsGroupItems<ITEMS_MODEL extends Types.GroupItemsModel = Types.GroupItemsModel> {
  private readonly _model: ITEMS_MODEL;

  constructor(model: ITEMS_MODEL) {
    this._model = model;
  }

  /**
   * Creates a new SettingItems instance from an array of items.
   */
  static fromArray<INPUT_FLAG_BODY extends Types.ItemBodyWithOptionalKeyModel>(
    items: INPUT_FLAG_BODY[]
  ): SettingsGroupItems<TransformToFlagsModel<WithKey<INPUT_FLAG_BODY>[]>> {
    return new SettingsGroupItems(
      items.filter(SettingsGroupItems.itemsWithKeys).reduce(
        (acc, item) => ({
          ...acc,
          [item.key]: item
        }),
        {} as TransformToFlagsModel<WithKey<INPUT_FLAG_BODY>[]>
      )
    );
  }

  static fromItemsModel<INPUT_ITEMS_MODEL extends Types.GroupItemsModel>(
    items: INPUT_ITEMS_MODEL
  ): SettingsGroupItems<INPUT_ITEMS_MODEL> {
    return new SettingsGroupItems<INPUT_ITEMS_MODEL>(items);
  }

  get model(): ITEMS_MODEL {
    return this._model;
  }

  private static itemsWithKeys<T extends { key?: string | null }>(item: T): item is WithKey<T> {
    return !!item.key;
  }
}

type WithKey<T extends { key?: string | null }> = T & { key: Defined<T['key']> };

type TransformToFlagsModel<T extends any[]> = T extends { key?: infer Key; enabled: boolean }[]
  ? { [prop in Key & string]: ArrayType<T> }
  : never;
